import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import React from "react";

// VFX: Before After Split
// Category: comparison · Tags: ui, before-after, comparison, split, product
export default function UiBeforeAfterSplit1000Ms() {
  const frame = useCurrentFrame();
  const { fps, width, height } = useVideoConfig();
  const left = spring({ frame, fps, config: { damping: 18 } });
  const right = spring({ frame: frame - 6, fps, config: { damping: 18 } });
  return (
    <AbsoluteFill style={{ background: "#0a0e1a" }}>
      <div style={{
        position: "absolute", inset: 0, width: "50%",
        background: "linear-gradient(135deg, #1e293b, #334155)",
        transform: `translateX(${interpolate(left, [0, 1], [-width / 2, 0])}px)`,
        display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",
        borderRight: "2px solid #ef4444",
      }}>
        <div style={{ color: "#ef4444", fontSize: 64, fontWeight: 900, letterSpacing: 4, fontFamily: "Inter" }}>BEFORE</div>
        <div style={{ color: "#94a3b8", fontSize: 32, marginTop: 16, fontFamily: "Inter" }}>Sem sistema</div>
      </div>
      <div style={{
        position: "absolute", inset: 0, left: "50%", width: "50%",
        background: "linear-gradient(135deg, #064e3b, #10b981)",
        transform: `translateX(${interpolate(right, [0, 1], [width / 2, 0])}px)`,
        display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",
      }}>
        <div style={{ color: "#f8fafc", fontSize: 64, fontWeight: 900, letterSpacing: 4, fontFamily: "Inter" }}>AFTER</div>
        <div style={{ color: "#d1fae5", fontSize: 32, marginTop: 16, fontFamily: "Inter" }}>Com Content OS</div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
